// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"e12b788d","475":"f6234f2f"}[chunkId] + ".chunk.js";
};